import styled from 'styled-components';
import { CreateButton } from '../../components/CreateSurveyModal/CreateSurveyModal.styles';
import { DefaultButton } from '../../styles/globals';
import { IThemeProvider, ITheme } from '../../styles/theme';

export const ModalBlackBG = styled.div`
  position: fixed;
  overflow: auto;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  width: 100%;
  height: 100%;
  background: rgba(45, 45, 45, 0.7);
`;

interface IModalCont {
  theme: ITheme;
  top?: string;
  width?: string;
  absolute?: boolean;
  right?: string;
}

export const ModalCont = styled.div<IModalCont>`
  min-height: 100px;
  z-index: 2000;
  left: 0;
  right: 0;
  margin: 0 auto;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  ${({ theme, top, width, absolute, right }: IModalCont) => `
    right: ${right || '0'};
    position: ${absolute ? 'absolute' : 'fixed'};
    width: ${width || '768px'};
    top: ${top || '-90px'};
    background: ${theme.colors.neutral.primary[5]};
  `};
`;

export const ModalHeader = styled.span`
  position: relative;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  height: 72px;
  width: 100%;
  ${({ theme }: IThemeProvider) => `
       padding: 0 ${theme.layout.spacing.decy};
       border-width:  0 0 1px 0;
       border: 1px solid ${theme.colors.neutral.primary[30]};
      border-width: 0 0 1px 0;
    `};
`;

export const CloseMarkCont = styled.div`
  position: absolute;
  cursor: pointer;
  right: 24px;
  top: 24px;
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  svg {
    height: 24px;
  }
`;

export const ModalBody = styled.div`
  display: flex;
  height: fit-content;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 56px 56px 32px;
`;

export const ModalFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  height: 80px;
  ${({ theme }: IThemeProvider) => `
       padding: 0 ${theme.layout.spacing.centy};
       border: 1px solid ${theme.colors.neutral.primary[30]};
       border-width: 1px 0 0 0;
    `};
`;

export const ModalActions = styled.div`
  display: flex;
  align-items: center;
`;

export const ActionButton = styled(DefaultButton)`
  width: auto;
  border-radius: 8px;
  border: none;
  text-transform: capitalize;
  min-width: 76px;

  > div {
    padding-bottom: 6px;

    .ant-spin-dot-item {
      background: #fff;
    }
  }

  ${({ theme }: IThemeProvider) => `
    margin: 0 0 0 ${theme.layout.spacing.centy};
    padding:  0 ${theme.layout.spacing.centy} 0 ${theme.layout.spacing.centy};
    background: ${theme.colors.primary[100]};
    color: ${theme.colors.neutral.primary[5]};
  `};
`;

export const CancelButton = styled(CreateButton)`
  display: flex;
  align-items: center;

  ${({ theme }: IThemeProvider) => `
    background: ${theme.colors.neutral.primary[0]};
    border: 2px solid ${theme.colors.primary[100]};
    color: ${theme.colors.primary[100]};
  `};
`;

export const XMarkCont = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;

  ${({ theme }: IThemeProvider) => `
    margin: 0 ${theme.layout.spacing.mikro} 0 0 0;

    svg {
      path {
        fill: ${theme.colors.primary[100]};
      }
    }
  `};
`;
